// Parser mínimo de frontmatter YAML (subset) — evita una dependencia extra.
// Soporta solo pares `clave: valor` simples, que es lo que usan los .md legales.

export interface LegalFrontmatter {
  title?: string;
  version?: string;
  /** ISO `YYYY-MM-DD`. */
  updated?: string;
  description?: string;
  /** `draft` muestra un banner de borrador en la página. */
  status?: string;
}

const FRONTMATTER_RE = /^﻿?---\s*\r?\n([\s\S]*?)\r?\n---\s*\r?\n?/;

export function parseFrontmatter(raw: string): {
  data: LegalFrontmatter;
  content: string;
} {
  const match = FRONTMATTER_RE.exec(raw);
  if (!match) return { data: {}, content: raw };

  const data: LegalFrontmatter = {};
  for (const line of match[1].split(/\r?\n/)) {
    const idx = line.indexOf(':');
    if (idx === -1) continue;
    const key = line.slice(0, idx).trim();
    if (!key) continue;
    let value = line.slice(idx + 1).trim();
    // Quita comillas envolventes (' o ").
    value = value.replace(/^["']|["']$/g, '');
    (data as Record<string, string>)[key] = value;
  }

  return { data, content: raw.slice(match[0].length) };
}

/** `2026-06-02` → `02/06/2026`. Devuelve el input si no matchea ISO. */
export function formatDateDMY(iso?: string): string | null {
  if (!iso) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso.trim());
  if (!m) return iso;
  return `${m[3]}/${m[2]}/${m[1]}`;
}

/** Construye la línea de pie: "Versión 1.0 · Última actualización 02/06/2026". */
export function buildVersionLine(fm: LegalFrontmatter): string | null {
  const parts: string[] = [];
  if (fm.version) parts.push(`Versión ${fm.version}`);
  const date = formatDateDMY(fm.updated);
  if (date) parts.push(`Última actualización ${date}`);
  return parts.length ? parts.join(' · ') : null;
}
